import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import ReactLoading from 'react-loading';

class ProtectedRoute extends Component {
    
    componentDidMount(){
        if(!Object.keys(this.props.user).length){
            this.props.setUser();
        }
    }

    render(){
        let { component, ...rest } =  this.props;
        const ComponentToRender = component;
        let user = this.props.user;
        // delete user["cognito:groups"]; //testing for unauthorized user
        console.log("USER", user);


        return  <Route exact {...rest} render={(props) => (
            this.props.userIsLoading 
            ?
            (
                <div className="col-12 loader">
                    <ReactLoading type={"spin"} color={"#666666"} height={'15%'} width={'15%'}/>
                </div>
            )
            :
            ( !!Object.keys(user).length 
                && user["cognito:groups"]
                && user["cognito:groups"].includes("ADMIN") )
            ?
            <ComponentToRender {...props} /> 
            :
            <Redirect to="/unauthorized" />
        )} />
    }

}

export default ProtectedRoute;


// WEBPACK FOOTER //
// ./src/components/Common/ProtectedRoute/ProtectedRoute.js